<?xml version="1.0" encoding="utf-8"?>
<!-- Generator: Adobe Illustrator 24.3.0, SVG Export Plug-In . SVG Version: 6.00 Build 0)  -->
<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" x="0px" y="0px"
	 viewBox="0 0 24 24" style="enable-background:new 0 0 24 24;" xml:space="preserve">
<style type="text/css">
	.st0{fill:#949497;}
</style>
<g>
	<path class="st0" d="M19.2,5.8l-1.5-0.2c0,0-0.1,0-0.1-0.1l-0.7-1.4c0-0.1-0.2-0.1-0.2,0L16,5.5l-0.1,0.1l-1.5,0.2
		c-0.1,0-0.1,0.1-0.1,0.2l1.1,1.1v0.1l-0.1,1.6c0,0.1,0.1,0.2,0.2,0.1l1.3-0.7h0.1l1.3,0.7c0.1,0,0.2,0,0.2-0.1l-0.3-1.6V7.1L19.3,6
		C19.3,5.9,19.3,5.8,19.2,5.8z"/>
	<path class="st0" d="M16.9,12.4c-1.1-1-2.2-2-3.2-3.1c-0.2-0.2-0.2-0.2-0.4,0c-0.8,0.5-1.6,0.9-2.4,1.3c-1.1,0.6-2.2,1.3-3.4,1.9
		c-0.2,0.1-0.3,0.2-0.2,0.4c0.2,0.8,0.4,1.5,0.6,2.3c0.3,1.5,0.5,3,0.5,4.5c0,0.2,0.1,0.3,0.3,0.2c0.4-0.1,0.8-0.3,1.2-0.3
		c0.3,0,0.4-0.2,0.3-0.5c-0.1-0.6-0.2-1.1-0.3-1.7c-0.1-0.4-0.1-0.9-0.2-1.3c0.2,0,0.2,0.1,0.3,0.2c0.5,0.8,0.9,1.7,1.4,2.5
		c0.1,0.2,0.2,0.2,0.4,0.1c0.7-0.3,1.3-0.6,2-0.9c0.1,0,0.1-0.2,0.1-0.2c-0.2-0.5-0.4-0.9-0.6-1.4c-0.2-0.5-0.4-1-0.5-1.5
		c0.1,0,0.1,0,0.2,0.1c0.6,0.7,1.2,1.4,1.8,2.1c0.2,0.2,0.3,0.2,0.5,0.1c0.6-0.4,1.2-0.9,1.8-1.3c-0.4-0.7-0.8-1.2-1.2-1.8
		c0,0,0,0,0.1-0.1c0.1,0,0.1,0.1,0.2,0.1c0.5,0.3,0.9,0.7,1.4,1c0.1,0.1,0.3,0.1,0.4,0c0.4-0.4,0.8-0.8,1.3-1.2
		c-0.2-0.1-0.3-0.2-0.4-0.3C18.1,13.3,17.5,12.9,16.9,12.4z"/>
	<path class="st0" d="M10.5,9.5c0.7-0.4,1.4-0.8,2.1-1.2c0.2-0.1,0.2-0.2,0.1-0.4c-0.6-0.7-1.3-1.1-2.1-1.1c-0.4,0-0.8,0-1.1,0
		c0-0.1,0-0.2-0.1-0.3C9.1,6.1,8.9,5.7,8.7,5.4C8.4,4.9,8.2,4.5,7.9,4H5.3c0.5,0.9,1,1.7,1.4,2.6C7,7,7.2,7.5,7.5,7.9
		C7.3,8.1,7.2,8.3,7,8.5c-0.6,1-0.6,2-0.3,3.1c0.7-0.4,1.3-0.7,1.9-1C9.3,10.2,9.9,9.8,10.5,9.5z"/>
</g>
</svg>
